const Gallery = () => {
    return (
        <>
            Gallery
        </>
    )
}
export default Gallery;